import { render, staticRenderFns } from "./EditDrawer.vue?vue&type=template&id=33cb8cb4&scoped=true"
import script from "./EditDrawer.vue?vue&type=script&lang=js"
export * from "./EditDrawer.vue?vue&type=script&lang=js"
import style0 from "./EditDrawer.vue?vue&type=style&index=0&id=33cb8cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb8cb4",
  null
  
)

export default component.exports